// extracted by mini-css-extract-plugin
export default {"preload":"ImageWithPreload-module__preload--REhCy","squareWrapper":"ImageWithPreload-module__squareWrapper--cikxy"};